<ion-card class="contacts-card">
  @if (!hasContacts$$() && !contactsLoading$$()) {
  <div class="empty-state">
    <ion-icon [src]="useDarkMode$$() ? 'assets/icons/dark/invite-contact-empty.svg' : 'assets/icons/light/invite-contact-empty.svg'" class="empty-illustration" />
    <lib-app-button data-testid="add-contact-button" [fill]="'clear'" class="empty-link" (click)="handleGoToContacts()">
      <ion-icon name="plus" class="link-icon"></ion-icon>
      {{ 'menu.contacts.empty.addContact' | transloco }}
    </lib-app-button>
  </div>
  } @if (contactsLoading$$() || hasContacts$$()) {
  <div class="contacts-content">
    <lib-contacts-avatars [contacts]="contacts$$()" [loading]="contactsLoading$$()" [maxDisplayed]="4" />
    <lib-app-button data-testid="view-all-contacts-button" [fill]="'clear'" class="contacts-link" [disabled]="contactsLoading$$()" (click)="handleGoToContacts()">
      <ion-icon name="arrow-right" class="link-icon" slot="end"></ion-icon>
      {{ 'menu.contacts.viewAll' | transloco }}
    </lib-app-button>
  </div>
  }
</ion-card>
